<template>
    <div>
        <div class="page-content top px-4">
            <template-breadcrumb v-if="isDataLoaded" :title="details.title" />
            <template-header v-if="isDataLoaded" :title="details.title" />
            <b-card footer-class="p-0" class="rounded-lg" :key="cardKey">
                <div class="profile-details">
                    <form>
                        <input type="hidden" name="id" :value="templateId" />
                    </form>

                    <loader-profile
                        v-if="!isDataLoaded"
                        :show-image="false"
                    ></loader-profile>

                    <b-row v-else-if="isDataLoaded">
                        <b-col lg="6">
                            <b-form-group
                                label-for="title"
                                label-cols="3"
                                label="Name:"
                            >
                                <b-input
                                    v-if="isEditMode"
                                    id="title"
                                    v-model="editDetails.title"
                                    :class="{
                                        'border-danger': errors.has('title')
                                    }"
                                    v-validate="'required'"
                                    name="title"
                                    type="text"
                                    placeholder="Title (required)"
                                    :disabled="isSavingEdit"
                                />
                                <b-input
                                    v-else
                                    plaintext
                                    :value="details.title"
                                />
                            </b-form-group>
                            <b-form-group
                                label-for="type"
                                label-cols="3"
                                label="Type:"
                            >
                                <b-input
                                    plaintext
                                    :value="
                                        details.template_type
                                            ? details.template_type.value
                                            : null
                                    "
                                />
                            </b-form-group>
                            <b-form-group
                                label-for="description"
                                label-cols="3"
                                label="Description:"
                            >
                                <b-textarea
                                    v-if="isEditMode"
                                    v-model="editDetails.description"
                                    name="description"
                                    placeholder="Description (optional)"
                                    :disabled="isSavingEdit"
                                />
                                <div
                                    v-else
                                    v-html="
                                        convertNewLineToBreak(
                                            details.description
                                        )
                                    "
                                ></div>
                            </b-form-group>
                        </b-col>
                        <b-col lg="6">
                            <b-form-group
                                label-for="created"
                                label-cols="3"
                                label="Created:"
                            >
                                <b-input
                                    plaintext
                                    :value="
                                        _carbonDateDisplay(details.create_at)
                                    "
                                />
                            </b-form-group>
                            <b-form-group
                                label-for="updated"
                                label-cols="3"
                                label="Updated:"
                            >
                                <b-input
                                    plaintext
                                    :value="
                                        _carbonDateDisplay(details.update_at)
                                    "
                                />
                            </b-form-group>
                            <b-form-group
                                label-for="lastUsed"
                                label-cols="3"
                                label="Last Used:"
                            >
                                <b-input
                                    plaintext
                                    :value="
                                        convertToDateFormat(details.last_used)
                                    "
                                />
                            </b-form-group>
                            <b-form-group
                                label-for="totalUse"
                                label-cols="3"
                                label="Total Use:"
                            >
                                <b-input
                                    plaintext
                                    :value="details.total_used"
                                />
                            </b-form-group>
                        </b-col>
                    </b-row>
                </div>
                <template v-slot:footer no-body>
                    <b-tabs card class="list" lazy v-if="templateId">
                        <b-tab active>
                            <template #title>
                                <i class="cus-page-white-lightning"></i>
                                Template
                            </template>
                            <b-card-text>
                                <b-button
                                    variant="secondary"
                                    @click="updateLetterContent"
                                >
                                    <i class="cus-disk"></i>
                                    Save
                                </b-button>
                                <b-row class="mt-3">
                                    <b-col class="side-content" sm="3">
                                        <template v-if="letterVariables">
                                            <ul
                                                style="
                                                    list-style-type: none;
                                                    padding-left: 5px;
                                                "
                                            >
                                                <span
                                                    v-for="parentVar in Object.values(
                                                        letterVariables
                                                    )"
                                                    :key="parentVar.id"
                                                >
                                                    <li
                                                        style="
                                                            margin-bottom: 5px;
                                                            cursor: pointer;
                                                        "
                                                        v-if="
                                                            parentVar.component
                                                                .length > 0
                                                        "
                                                    >
                                                        <div
                                                            @click="
                                                                parentVar.isShownChild = !parentVar.isShownChild
                                                            "
                                                        >
                                                            <i
                                                                style="
                                                                    cursor: pointer;
                                                                "
                                                                :class="
                                                                    parentVar.isShownChild
                                                                        ? 'cus-control-play-blue-down'
                                                                        : 'cus-control-play-blue'
                                                                "
                                                            ></i>

                                                            <span>{{
                                                                parentVar.label
                                                            }}</span>
                                                        </div>
                                                        <template
                                                            v-if="
                                                                parentVar.isShownChild
                                                            "
                                                        >
                                                            <ul
                                                                style="
                                                                    list-style-type: none;
                                                                    margin-top: 5px;
                                                                "
                                                            >
                                                                <li
                                                                    v-for="childVar in Object.values(
                                                                        parentVar.component
                                                                    )"
                                                                    :key="
                                                                        childVar.id
                                                                    "
                                                                    style="
                                                                        margin-bottom: 5px;
                                                                        cursor: pointer;
                                                                    "
                                                                >
                                                                    <div
                                                                        @click="
                                                                            addLetterVariable(
                                                                                childVar.componentSnippet
                                                                            )
                                                                        "
                                                                    >
                                                                        <i
                                                                            class="non-draggable"
                                                                            :class="'cus-add'"
                                                                        ></i>

                                                                        <span
                                                                            draggable="true"
                                                                            @dragstart="
                                                                                onDragStart(
                                                                                    childVar.componentSnippet,
                                                                                    $event
                                                                                )
                                                                            "
                                                                            >{{
                                                                                childVar.label
                                                                            }}</span
                                                                        >
                                                                    </div>
                                                                </li>
                                                            </ul>
                                                        </template>
                                                    </li>
                                                </span>
                                            </ul>
                                        </template>
                                    </b-col>
                                    <b-col sm="9">
                                        <b-card-text>
                                            <tinymce
                                                :init="tinymceConfig"
                                                v-model="letterContent"
                                                @drop="handleDrop"
                                                @dragover.prevent
                                            />
                                        </b-card-text>
                                    </b-col>
                                </b-row>
                            </b-card-text>
                        </b-tab>
                    </b-tabs>
                </template>
            </b-card>
        </div>
    </div>
</template>

<script>
import { DateTime } from "luxon";
import tinymce from "@tinymce/tinymce-vue";
import tinymceHelper from "@/module/commons/helper-tinymce";
import TEMPLATES from "@/constants/templates";
import TEMPLATE_SERVICES from "@/services/templates";
import TEMPLATE_LETTER_SERVICES from "@/services/template-letter";
import { map } from "lodash";
import SettingTemplateMixin from "@/mixins/settings-template";

export default {
    mixins: [SettingTemplateMixin],
    components: {
        tinymce,
        TemplateBreadcrumb: () => import("./breadcrumb.vue"),
        TemplateHeader: () => import("@/module/settings/template/header.vue"),
        LoaderProfile: () => import("@/components/elements/loader-profile.vue")
    },
    data() {
        return {
            templateId: null,
            isDataLoaded: false,
            tinymceConfig: {
                ...tinymceHelper.core, // use spread operator to inject all vetter-related configs
                toolbar: tinymceHelper.toolbar.default, // default | communication
                plugins: tinymceHelper.plugins,
                height: 800
            },
            letterContent: null,
            letterVariables: null,
            isCollapsed: false,
            cardKey: 0
        };
    },
    computed: {
        details: {
            get() {
                return this.$store.state.settingsTemplate.details;
            },
            set(value) {
                this.$store.commit("settingsTemplate/setDetails", value);
            }
        },
        editDetails: {
            get() {
                return this.$store.state.settingsTemplate.editDetails;
            },
            set(value) {
                this.$store.commit("settingsTemplate/setEditDetails", value);
            }
        },
        isEditMode: {
            get() {
                return this.$store.state.settingsTemplate.isEditMode;
            }
        },
        isSavingEdit() {
            return this.$store.state.settingsTemplate.isSavingEdit;
        },
        routeParam() {
            return this.$route.params.id;
        }
    },
    watch: {
        routeParam() {
            this.fetchData();
            this.fetchLetterTemplateVariablesList();

            this.cardKey++;
        }
    },
    mounted() {
        this.fetchData();
        this.fetchLetterTemplateVariablesList();

        this.$store.commit(
            "settingsTemplate/setTemplateType",
            TEMPLATES.TYPE.LETTER
        );
    },
    beforeDestroy() {
        // clear vuex store
        this.$store.dispatch("settingsTemplate/reset");
    },
    methods: {
        onDragStart(snippet, event) {
            event.dataTransfer.setData("text/html", snippet);
        },
        handleDrop(event) {
            event.preventDefault();
            const data = event.dataTransfer.getData("text/html");
            if (data) {
                const editor = tinymce.activeEditor;
                editor.execCommand("mceInsertContent", false, data);
            }
        },
        errorClass(key) {
            return {
                "border-danger": this.errors.has(key)
            };
        },
        addLetterVariable(snippet) {
            // eslint-disable-next-line no-undef
            tinyMCE.activeEditor.focus();
            // eslint-disable-next-line no-undef
            tinyMCE.activeEditor.insertContent(snippet);
        },
        async fetchData(updatedData = null) {
            try {
                this.isDataLoaded = false;
                let encodedTemplateId = this.$route.params.id;
                this.templateId = null;

                // fetch details
                let fetchDetails = updatedData;
                if (!updatedData) {
                    fetchDetails = await this.$http.get(
                        `${process.env.BARRAMUNDI}account/template/${encodedTemplateId}?encoded=true`
                    );
                }

                let res = fetchDetails.data.response;
                this.details = res.resources || res.resource;
                this.details.title = this.details.name;
                this.templateId = this.details.id;

                this.isDataLoaded = true;

                this.validateTemplateType(
                    this.details.type,
                    TEMPLATES.TYPE.LETTER
                );

                // store templateId in vuex
                this.$store.commit("settingsTemplate/setTemplateId", this.templateId); // prettier-ignore
            } catch (error) {
                this.isDataLoaded = true;
                this._message(error.message, "danger");
            }
        },
        async fetchLetterTemplateVariablesList() {
            try {
                let encodedTemplateId = this.$route.params.id;

                let res = await TEMPLATE_LETTER_SERVICES.getLetterTemplateVariablesList(
                    encodedTemplateId
                );

                if (res.message?.code == 200) {
                    if (res.resources) {
                        this.letterContent = res.resources.letter_content;
                        this.letterVariables = map(
                            res.resources.letter_side,
                            dat => ({ ...dat, isShownChild: false })
                        );
                    } else {
                        throw new Error(
                            "Failed to get template variables list"
                        );
                    }
                } else {
                    throw new Error("Failed to get template variables list");
                }
            } catch (error) {
                this._message(error.message, "danger");
            }
        },
        async updateLetterContent() {
            try {
                let res = await TEMPLATE_LETTER_SERVICES.putLetterTemplateContent(
                    this.templateId,
                    this.letterContent
                );

                if (res.state == 200) {
                    this._message(res.message);
                } else {
                    throw new Error("Failed to update letter content");
                }
            } catch (error) {
                this._message(error.message, "danger");
            }
        },
        convertToDateFormat(epochTimestamp) {
            if (!epochTimestamp) {
                return "";
            }

            // Convert epoch timestamp in seconds to milliseconds for Luxon
            const dateTime = DateTime.fromMillis(epochTimestamp * 1000);

            // Format the date as desired, e.g., "yyyy-MM-dd"
            return dateTime.toFormat(this._dateFormat);
        },
        async saveDetails() {
            let self = this;

            this.$store.commit("settingsTemplate/toggleSavingEdit", true);

            try {
                let isValid = await this.$validator.validateAll();

                if (!isValid) {
                    this.errors
                        .all()
                        .forEach(error => self._message(error, "danger"));
                    this.$store.commit(
                        "settingsTemplate/toggleSavingEdit",
                        false
                    );
                    return;
                }

                let res = await TEMPLATE_SERVICES.putUpdateLetter(
                    this.templateId,
                    {
                        id: this.templateId,
                        type: this.editDetails.template_type.id,
                        name: this.editDetails.title,
                        description: this.editDetails.description
                    }
                );

                this.$store.commit("settingsTemplate/commitEditDetails");

                this.fetchData(res);

                this._message("Record saved");
            } catch (error) {
                console.log(error);
                this._message("Error saving data", "danger");
            }

            this.$store.commit("settingsTemplate/toggleSavingEdit", false);
        }
    }
};
</script>

<style scoped>
.side-content {
    border-right: 1px solid #eee;
}
.top {
    margin-top: 10px;
    margin-bottom: 3px;
}
</style>
